import { Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';

import { LanguagesSelectService } from '../store/selectors/languages.selector';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  locale: Signal<string>;
  locale$: Observable<string>;

  constructor(private _languagesSelect: LanguagesSelectService) {
    this.locale$ = this._languagesSelect.getSelectedCode();
    this.locale = toSignal(this.locale$, {
      initialValue: 'en',
    });
  }
}
